import React from 'react';
import {template} from "@jorsek/content-portal-utils";
import {withRouter} from "next/router";

const DEFAULT_LOGIN_ROUTE = `/login`;

class ErrorHandler extends React.Component<{ router: any, statusCode: any, errorRedirects: any }> {
    static async getInitialProps({req, err}) {
        const statusCode = req?.query?.statusCode || err?.config?.statusCode;
        let errorRedirects = req?.runtimeConfig?.errorRedirects || {};
        if (statusCode) {
            const destination = errorRedirects[statusCode] || errorRedirects["*"];
            if (destination) {
                return {
                    redirect: {
                        destination: template(destination, {request: req, error: err}),
                        permanent: false,
                    }
                }
            }
        } 
        if (req?.runtimeConfig?.authRequired && (statusCode === 401 || statusCode === 403)) {
            return {
                redirect: {
                    destination: `${DEFAULT_LOGIN_ROUTE}?state=${req.path}`,
                    permanent: false,
                }
            }
        }
        return {
            props: {
                statusCode,
                errorRedirects
            }
        }
    }

    componentDidMount() {
        const {
            statusCode = '',
            errorRedirects = {}
        } = this.props;
        if (!this.props.router.asPath.startsWith("/error")) {
            const defaultErrorPath = `/error?path=${this.props.router.asPath}${statusCode ? `&statusCode=${statusCode}` : ''}`;
            const errorPath = errorRedirects[statusCode] || defaultErrorPath;
            return this.props.router.push(errorPath, errorPath, {shallow: false});
        }
    }

    render() {
        return null;
    }

}

export default withRouter(ErrorHandler);
